import * as React from "react";
import Feed from "../../_data/models/Feed";
import Meta from "../../_data/models/Meta";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import ActivityFeedModalContainer from "../containers/ActivityFeedModalContainer";
import ActivityFeedItemContainer from "../containers/ActivityFeedItemContainer";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import {Map} from "immutable";
import {History} from "history";

interface Props {
    feeds: Map<number, Feed>;
    meta: Meta;
    loading: boolean;
    loadMore: (meta: Meta) => void;
    openModal: boolean;
    selectedFeedId: number;
    history: History;
    currentUserID: number;
}

const ActivityFeedComponent = (props: Props) => {
    const {feeds, loading, loadMore, meta, openModal, selectedFeedId, history, currentUserID} = props;
    const showModal = openModal && feeds.get(selectedFeedId);

    return (
        <div className="row expanded">
            <div className="medium-12 columns">
                <ReduxInfiniteScroll
                    loadMore={() => loadMore(meta)}
                    elementIsScrollable={false}
                    loadingMore={loading}
                    loader={<LoadingIndicatorComponent/>}
                    threshold={200}>
                    {
                        feeds.toArray().map((feed) => <ActivityFeedItemContainer feed={feed} key={feed.id} currentUserID={currentUserID}/>)
                    }
                </ReduxInfiniteScroll>

                {showModal &&
                <ActivityFeedModalContainer history={history} id={selectedFeedId} currentUserID={currentUserID}/>
                }
            </div>
        </div>
    );
};
export default ActivityFeedComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/components/ActivityFeedComponent.tsx